<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn
          text
          icon
          v-on="on"
          @click="toggleFullScreen"
        >
          <v-icon v-show="!isFullScreen">fal fa-expand</v-icon>
          <v-icon v-show="isFullScreen">fal fa-compress</v-icon>
        </v-btn>
      </template>
      <span v-show="!isFullScreen">{{ $t('Full Screen') }}</span>
      <span v-show="isFullScreen">{{ $t('Normal Screen') }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import screenfull from 'screenfull'

export default {
  name: 'FullScreenSwitcher',

  computed: {
    ...mapState(['isFullScreen'])
  },

  mounted () {
    document.addEventListener('fullscreenchange', this.eventListener)
  },

  beforeDestroy () {
    document.removeEventListener('fullscreenchange', this.eventListener)
  },

  methods: {
    eventListener (event) {
      this.$store.dispatch('SET_FULLSCREEN', !this.isFullScreen)
    },

    toggleFullScreen () {
      if (screenfull.isEnabled) {
        screenfull.toggle().catch(err => console.log(err))
      }
    }
  }
}
</script>
